import 'core-js/stable/array/from';
import simplify from 'simplify-js';
import * as Map from './polygon';

class Drawing {
	switch_mode(new_mode) {
		const is_draw = new_mode == 'draw';

		// Events

		if (!is_draw) {
			google.maps.event.removeListener(this._mousedown_event);
			google.maps.event.removeListener(this._mousemove_event);
		}

		if (new_mode != 'delete') {
			this.polygons.forEach(
				polygon => {
					google.maps.event.clearListeners(polygon.polygon, 'click');
					polygon.clickable = false;
				}
			);
		}

		// Disable scroll for Chrome: https://stackoverflow.com/a/42288481/2630849
		document.body.style.touchAction = is_draw ? 'none' : null;

		// Disable scroll for Safari: https://stackoverflow.com/a/7771215/2630849
		document.ontouchmove = event => {
			if (is_draw) event.preventDefault();
		};

		// Buttons

		Array.from(this.drawing_controls.children).forEach(
			button => button.classList.remove('active')
		);
		this[`${new_mode}_button`].classList.add('active');

		// Map state

		this.map.google_map.setOptions({
			gestureHandling: is_draw ? 'none' : 'auto',
			draggableCursor: is_draw ? 'crosshair' : null
		});
	}

	constructor(map, options) {
		this.map = map;

		if (options.hidden_data_input_template_selector) {
			const hidden_data_input_template =
				document.querySelector(options.hidden_data_input_template_selector);

			this.hidden_input_container = hidden_data_input_template.parentNode;

			hidden_data_input_template.removeAttribute('id');
			this.hidden_data_input_template = hidden_data_input_template;
			hidden_data_input_template.remove();

			this.hidden_id_input_template = hidden_data_input_template.cloneNode();
			this.hidden_id_input_template.name =
				this.hidden_id_input_template.name.replace('[data]', '[id]');
		}

		this.polygons = [];

		// Draw existing polygons

		this.map.google_map.data.forEach(feature => {
			// Add hidden input
			this._add_polygon([], feature.getId());
		});

		if (options.existing_data) {
			options.existing_data.forEach(existing_polygon => {
				const points =
					JSON.parse(
						existing_polygon.data.replace(/\(/g, '[').replace(/\)/g, ']')
					)
						.map(point => new google.maps.LatLng(point[0], point[1]));

				this._add_polygon(points, existing_polygon.id);
			});
		}

		// Initialize controls

		this.drawing_controls =
			document.querySelector(options.controls_template_selector);

		if (!this.drawing_controls) return;

		this.drawing_controls.remove();

		[this.move_button, this.draw_button, this.delete_button] =
			Array.from(this.drawing_controls.querySelectorAll('button'));

		this.map.google_map.controls[google.maps.ControlPosition.TOP_CENTER]
			.push(this.drawing_controls);

		this.switch_mode('move');

		// Initialize controls events

		this.move_button.addEventListener('click', () => {
			this.switch_mode('move');
		});

		this.draw_button.addEventListener('click', () => {
			this.switch_mode('draw');

			this._create_draw_events();
		});

		const mapObject = this.map;
		this.delete_button.addEventListener('click', () => {
			this.switch_mode('delete');

			if (mapObject.container.dataset.isGeometry === 'true') {
				// If the data is in GeoJSON
				const data = mapObject.google_map.data;
				google.maps.event.addListener(data, 'click', event => {
					const associatedPolygon = this.polygons.find(polygon =>
						polygon.hidden_id_input.defaultValue ===
							event.feature.getId().toString());
					if (associatedPolygon) associatedPolygon.remove();
					data.remove(event.feature);
				});
			} else {
				// If the data is in polygons
				this.polygons.forEach(
					polygon => {
						polygon.clickable = true;

						google.maps.event.addListenerOnce(polygon.polygon, 'click', () => {
							polygon.remove();
							this.polygons.splice(this.polygons.indexOf(polygon), 1);
							mapObject.zoom_to_objects();
							this._toggle_carrier_tutorial_next_button();
						});
					}
				);
			}
		});
	}

	_create_draw_events() {
		let polyline;

		this._mousedown_event = google.maps.event.addListenerOnce(
			this.map.google_map, 'mousedown', () => {
				polyline = new google.maps.Polyline(
					Object.assign({}, Map.Polygon.default_shape_options, {
						map: this.map.google_map,
					})
				);

				this._mousemove_event = google.maps.event.addListener(
					this.map.google_map, 'mousemove', event => {
						polyline.getPath().push(event.latLng);
					}
				);

				google.maps.event.addListenerOnce(
					this.map.google_map, 'mouseup', () => {
						polyline.setMap(null);

						this._add_polygon(
							simplify(
								polyline.getPath().getArray().map(
									point => ({ x: point.lat(), y: point.lng() })
								),
								// Found emperically
								0.0001
							).map(point => new google.maps.LatLng(point.x, point.y))
						);

						this.switch_mode('move');
						this._toggle_carrier_tutorial_next_button();
					}
				);
			}
		);
	}

	_toggle_carrier_tutorial_next_button() {
		const modal_el = $('#tutorial_specify_regions');

		if (modal_el.length === 0) return;

		const no_polygons =
			$('[name="carrier[polygon_regions][][data]"]').length === 0;
		modal_el.find('progress, span').toggleClass('full_width', no_polygons);
		modal_el.find('.button_container').toggleClass('hidden', no_polygons);
	}

	_add_polygon(points, id = null) {
		this.polygons.push(
			new Map.Polygon(points, this.map.google_map, {
				id: id,
				hidden_input_container: this.hidden_input_container,
				hidden_data_input_template: this.hidden_data_input_template,
				hidden_id_input_template: this.hidden_id_input_template
			})
		);
	}
}

export { Drawing };
